<template>
  <v-layout column flat class="grey8 pa-3">
    <div class="di-flex align-end">
      <v-avatar tile size="64">
        <img :src="customer.image || defaultImage" alt="" />
      </v-avatar>
      <div>
        <h3 class="px-3">{{ customer.name }}</h3>
        <h4 class="px-3">{{ customer.id }} - {{ $t(customer.type) }}</h4>
        <h4
          v-if="next_kyc_date"
          class="px-3"
          :class="{
            'red--text': isExpired,
          }"
        >
          {{ $t("next_kyc_date") }}:
          {{ next_kyc_date }}
        </h4>
         <h4
          class="px-3"
          v-if="license_date"
          :class="{
            'red--text': isLicenseExpired,
          }"
        >
          {{ $t("license_expire_date") }}:
          {{ license_date }}
        </h4>
      </div>
    </div>
    
    <v-divider class="my-3"></v-divider>
    <!-- <h3 class="mb-3">{{ $t("accounts_balance") }}</h3> -->
    <template v-for="(account, index) in customer.accounts">
      <h4
        :key="index"
        v-if="account.balance != 0"
        class="text-xs-left"
        :class="{
          'activeColor--text': account.balance > 0,
          'red--text': account.balance < 0,
        }"
      >
        <span>{{ account.name }} : </span>
        <span>{{ account.balance | currency() }}</span>
      </h4>
      <v-divider
        class="my-1"
        :key="index + 'd'"
        v-if="account.balance != 0"
      ></v-divider>
    </template>

    <!-- <customer-image
      size="100"
      v-model="customer.image"
      :readonly="true"
    /> -->
  </v-layout>
</template>
<script>
export default {
  props: {
    customer: {
      default: () => ({
        accounts: [],
        image: require("@/assets/images/userplaceholder.svg"),
      }),
    },
  },
  data: () => ({
    defaultImage: require("@/assets/images/userplaceholder.svg"),
  }),
  computed: {
    next_kyc_date() {
      if (this.customer.type == "individual")
        return this.customer.individual.next_kyc_date;
      else if (this.customer.type == "corporate")
        return this.customer.corporate.next_kyc_date;
      return "";
    },

    license_date() {
      if (this.customer.type == "corporate")
        return this.customer.corporate.license_expire_date;
      return "";
    },
    isExpired() {
      let now = new Date();
      now.setDate(now.getDate() + 5);
      return new Date(this.next_kyc_date) <= now;
    },
    isLicenseExpired() {
      let now = new Date();
      now.setDate(now.getDate() + 5);
      return new Date(this.license_date) <= now;
    },
  },
};
</script>